module.exports = __webpack_public_path__ + "static/media/header.9211ef85.png";